import { QueryResult } from 'react-query';
import { callApi, Controller, useApi, UseApiOptions } from './useApi';
import { ArtikelDetail } from './artikelDetail';
import { ArtikelDetailLieferant } from './artikelDetailLieferant';

export interface BestellungPosition {
    bNr: string;
    artikelGruppeNr: number;
    artikelNr: string;
    pos: number;
    posText: string;
    posEinh: string;
    posMenge: number;
    posEkPreis: number;
    posEPreis: number;
    posNetto: number;
    posMwst: number;
    posBrutto: number;
    posBem: string;
    offen: number;
    lArt: string;

    updDat?: string;
    updUhr?: number;
    updUser?: string;

    artikelDetail?: ArtikelDetail;
    hauptlieferant?: ArtikelDetailLieferant;

    transfer?: boolean;
    transferMenge?: number;
    transferLArt?: string;
}

export interface BestellungPositionFilter {
    bNrList?: string[];
    kNr?: number;
    bNr?: string;
    pos?: number;

    withArtikelDetail?: boolean;
    withHauptlieferant?: boolean;
}

export const defaultBestellungPosition: BestellungPosition = {
    bNr: '',
    artikelGruppeNr: 0,
    artikelNr: '',
    pos: -1, // -1 = new
    posText: '',
    posEinh: '',
    posMenge: 0,
    posEkPreis: 0,
    posEPreis: 0,
    posNetto: 0,
    posMwst: 20,
    posBrutto: 0,
    posBem: '',
    offen: 0,
    lArt: '',
};

export function useBestellungPositionList(
    filter: BestellungPositionFilter,
    apiOptions?: UseApiOptions<BestellungPosition[]>,
): QueryResult<BestellungPosition[]> {
    return useApi<BestellungPosition[]>(Controller.bestellungPosition + '/list', { filter }, apiOptions);
}

interface AddBestellungPositionResult {
    newNr: number;
}

export async function addBestellungPosition(
    bestellungPosition: BestellungPosition,
): Promise<AddBestellungPositionResult> {
    return callApi<AddBestellungPositionResult>(Controller.bestellungPosition + '/add', { bestellungPosition });
}

export async function updateBestellungPosition(bestellungPosition: BestellungPosition): Promise<void> {
    return callApi<void>(Controller.bestellungPosition + '/update', { bestellungPosition });
}

export async function deleteBestellungPosition(bestellungPosition: BestellungPosition): Promise<void> {
    return callApi<void>(Controller.bestellungPosition + '/delete', { bestellungPosition });
}

export async function moveUpBestellungPosition(bNr: string, pos: number): Promise<void> {
    return callApi<void>(Controller.bestellungPosition + '/moveup', {
        bestellungPosition: {
            bNr,
            pos,
        },
    });
}

export async function changeBestellungPositionMenge(
    bestellungPosition: BestellungPosition,
    changeBestand: boolean,
): Promise<void> {
    return callApi<void>(Controller.bestellungPosition + '/changeMenge', { bestellungPosition, changeBestand });
}
